import Footer from '@/components/Layout/Footer/Footer';
import React, { useEffect, useState } from 'react';
import UserHeadBar from '../../components/UserHeadBar';
import 'react-responsive-modal/styles.css';
import { Button } from '@/components/Elements';
import share from '@/assets/detail.png';
import bed from '@/assets/bde.svg';
export const DealDetails = () => {
  return (
    <>
      <UserHeadBar content={'View all of your shares related decisions here.'} />
      <div className="container">
        <div className="row my-5">
          <div className="col-12 col-md-7 col-xl-8">
            <div className="buy-card">
              <img src={share} className="" />
            </div>
          </div>
          <div className="col-12 col-md-5 col-xl-4">
            <div className="buy-card detail">
              <h5 className="text-dark f-18 font-semibold mb-1">Details</h5>
              <hr />
              <h6 className="f-16 text-dark mb-0">Woodland Apartments</h6>
              <p className="hr2 f-13 mb-0">
                <i className="fa-solid fa-location-dot"></i> New York, USA
              </p>
              <div className="apartment-details">
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Share Invested in</span>
                  <span className="font-semibold">$500</span>
                </p>
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Buyer Name</span>
                  <span className="font-semibold">Johan Doe</span>
                </p>
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Date/Time</span>
                  <span className="font-semibold">15-11-24 16:47 pm</span>
                </p>
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Phone Number</span>
                  <span className="font-semibold">9854212356</span>
                </p>
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Email</span>
                  <span className="font-semibold">example123@gmaiol.com</span>
                </p>
                <p className="f-14 text-dark d-flex border-btm mb-0 py-2 justify-between">
                  <span>Date</span>
                  <span className="font-semibold">15-11-24</span>
                </p>
              </div>
              <div className="buy-beds my-3 d-flex f-13 text-dark">
                <div className="d-flex gap-1 items-center buy-bed-flx">
                  <img src={bed} className="buy-bed-icon" /> 8 Beds
                </div>
                <div className="d-flex gap-1 items-center buy-bed-flx">
                  <img src={bed} className="buy-bed-icon" /> 2 Bath
                </div>
                <div className="d-flex gap-1 items-center buy-bed-flx">
                  <img src={bed} className="buy-bed-icon" /> 123 Sqft
                </div>
              </div>
              <h5 className="f-16 font-semibold text-dark">Overview</h5>
              <p className="f-13">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since Read More ....
              </p>
              <Button className="w-full rounded-full mt-4">View Message</Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
